import React, { Component } from 'react';
import { Redirect } from "react-router-dom";
import { Row, Col, Grid, Table, Popover, OverlayTrigger } from "react-bootstrap";
import DatePicker from 'react-date-picker';
import Switch from "react-switch";
import Select from 'react-select';
import { toast } from 'react-toastify';

import Preloader from "../../views/Preloader/Preloader";

import { ConsultCuenta } from "../../funciones/EstCuentaFunction";
import { CustomCard } from "../../components/Card/CustomCard";
import CustomModal from "../../components/Modal/CustomModal";
import CustomModalHome from "../../components/Modal/CustomModalHome";


import { InfoUC, InfoPago } from '../../funciones/InscripcionFunction';
import { ConsultaDeuda, Pagar, ConsultaNumCuenta, PagoEfectivo } from '../../funciones/EstCuentaFunction';
import { formatNumber, formatReconver } from "../../funciones/GeneralFunctions";

let statusUser = 0;
let fecha = new Date();
let errores = 0;
let pagoHab = "";

class EstadoDeCuenta extends Component {
    state = {
        asientos: [],
        notificacionStyles: {
            fontSize:12, position:"absolute", top: 4
        },
        ValorUc: "",
        textPrelCuenta: <React.Fragment><i className="fa fa-spinner fa-spin"></i> Cargando</React.Fragment>,
        deudaT: {
            info: "Verificando Información, espera por favor",
            classInfo: "custom-alert-info",
            icono: "fa fa-circle-o-notch fa-spin"
        },
        openWPago: false,
        button1: {
            icon:"fa fa-check",
            text:"Registrar",
            disabled: false
        },
        openWCita: false,
        button2: {
            icon:"fa fa-send",
            text:"Enviar",
            disabled: false
        },
        num:"",
        fecha: fecha,
        otroMonto: "",
        total: true,
        otro: false,
        nuCuenta: [],
        selectcuenta: { value: '', label: ' - Selecciona una Cuenta - ', oblig: 1 },
        cuentas: [{ value: '', label: ' Cargando ', tipo: '', oblig: 1 }],
        titular: "",
        ciTitular: "",
        tlfTitular: "",
        concepto: "",
        SpagoHab: false,
        openHome: false,
    }

    componentWillMount = () => {
        ConsultCuenta ((resp) => {
            let textCuenta = this.state.textPrelCuenta;

            if (resp.length === 0){
                statusUser = 1
            }else{
                statusUser = 2;
                textCuenta = ""
            }
            this.setState({
                asientos: resp,
                textPrelCuenta: textCuenta,
                openHome: true,
            })
        })

        InfoUC ((resp) => {
            this.setState({ValorUc: resp})
        })

        InfoPago ((resp) => {
            pagoHab = resp
            this.setState({SpagoHab: resp})
        })

        ConsultaDeuda ((resp) => {
            errores = resp.errores;
            this.setState({deudaT: resp})
        })

        ConsultaNumCuenta ((resp) => {
            this.setState({
                nuCuenta: resp[0],
                cuentas: resp[1]
            })
        })
    }

    cambiaValor = (prop) => (e) => {
        this.setState({
            openHome: false,
            [prop]: (e.target.value).toUpperCase()
        })
    }

    cambiaFecha = (date) => {
        this.setState({
            openHome: false,
            fecha: date
        });
    }

    valorCuenta = (selectcuenta) => {
        this.setState({
            openHome: false,
            selectcuenta
        });
    }

    pagar = (prop) => {
        this.setState({
            openHome: false,
            total: false,
            otro: false,
        }, () => { 
            this.setState({[prop]: true})
        })
    }

    ayuda = () => (
        <Row>
            <Col md={12} align="justify">
                En esta sección podrás ver un resumen de los cobros facturados, tus pagos y tu saldo (Balance) disponible
            </Col>
            <Col md={12} align="justify">
                También puedes ingresar los datos de la transferencia relizada.
            </Col>
            <Col md={12} className="custom-mt-10">
                <strong style={{color:"#1f2f6e"}}>Estado de Cuenta:</strong>
            </Col>
            <Col md={3}><strong>N°</strong></Col>
            <Col md={9} align="justify">
                Representa el número de la transacción (Control Interno)
            </Col>
            <Col md={3}><strong>Fecha</strong></Col>
            <Col md={9} align="justify">
                Fecha de realizacion de la transacción
            </Col>
            <Col md={3}><strong>Descripción</strong></Col>
            <Col md={9} align="justify">
                Muestra los detalles de la transacción (en caso de un pago mostrará la referencia bancaria, y el retalle del pago)
            </Col>
            <Col md={3}><strong>Facturado</strong></Col>
            <Col md={9} align="justify">
                Es la cantidad de cobro en Bolívares por parte de la instirución (Inscripcion, Cuotas, Incrementos, etc.)
            </Col>
            <Col md={3}><strong>Pagado</strong></Col>
            <Col md={9} align="justify">
                Representa los pagos que has realizado
            </Col>
            <Col md={3}><strong>Balance</strong></Col>
            <Col md={9} align="justify">
                Es el saldo deudor disponible. <strong>(Un balance negativo significa saldo a tu favor)</strong>
            </Col>

            <Col md={12} className="custom-mt-10">
                <strong style={{color:"#1f2f6e"}}>Estatus:</strong>
            </Col>
            <Col md={12} align="justify">
                A la derecha de cada transacción puedes ver un ícono que representa su estado actual:
            </Col>
            
            <Col md={2}className="custom-mt-10"><i className="fa fa-check-circle text-success"></i></Col>
            <Col md={10} align="justify" className="custom-mt-10">
                Indica que la transacción esta aprobada
            </Col>
            <Col md={2} className="custom-mt-10"><i className="fa fa-exclamation-triangle text-warning"></i></Col>
            <Col md={10} align="justify" className="custom-mt-10">
                Indica que la transacción está pendiente por aprobación
            </Col>
            <Col md={2} className="custom-mt-10"><i className="fa fa-times-circle text-danger"></i></Col>
            <Col md={10} align="justify" className="custom-mt-10">
                Este ícono representa un error en la transacción o que la transacción es inválida, en este caso deberás ponerte en contacto con administración
            </Col>

            <Col md={12} className="custom-mt-10">
                <strong style={{color:"#1f2f6e"}}>Pagos Pendientes:</strong>
            </Col>
            <Col md={3}><strong>Deuda Pendiente</strong></Col>
            <Col md={9} align="justify">
                Representa el monto facturado vigente (También puedes observar la fecha de vencimiento)
            </Col>
            <Col md={3}><strong>Deuda Vencida</strong></Col>
            <Col md={9} align="justify">
                Es el monto correspondiente a pagos vencidos faltantes
                <div><strong>Importante: Si tienes deudas vencidas deberás pagar el interés por concepto de mora. Además quedarás inhabilitado para usar el sistema</strong></div>
            </Col>
            <Col md={12} className="custom-mt-10" align="justify">
                El botón <button className="btn btn-relleno-danger btn-xs" style={{borderWidth: 1}}><i class="fa fa-money"></i> Registrar Pago</button> permite ingresar los datos de la transferencia realizada
            </Col>
        </Row>
    )

    showModalCita = () => {
        const { openWCita, button2 } = this.state;

        let contenidoMess = () => (
            <Row>
                <Col md ={12}>
                    Esta opción envía una notificación a administración. Ellos la evaluarán y <strong>te mandarán una cita</strong> por correo del día que debes asistir con el pago en efectivo.
                    <div className = "text-danger" align = "right"><strong>¿Deseas solicitar la cita para el pago en efectivo?</strong></div>
                </Col>
            </Row>
        )

        let enviar = () => {
            if (button2.disabled === true) return null;
            this.setState({
                openHome: false,
                button2: {
                    icon:"fa fa-spinner fa-spin",
                    text:"Enviando Solicitud",
                    disabled: true
                }
            }, () => {
                PagoEfectivo((resp) => {
                    this.setState({
                        openWPago: false,
                        button1: {
                            icon:"fa fa-check",
                            text:"Registrar",
                            disabled: false
                        },
                        openWCita: false,
                        button2: {
                            icon:"fa fa-send",
                            text:"Enviar",
                            disabled: false
                        }
                    }, () => {
                        toast[resp.status](resp.mess,{autoClose: 4000});
                    })
                })
            })
        }

        return (
            <CustomModal
                backgroundColor = "#4aa5a5"
                isopen =  {openWCita}
                titulo = {<div style={{fontSize: 14, color: "#fff"}}><i className="fa fa-exclamation-triangle"></i> IMPORTANTE</div>}
                contenido = {contenidoMess()}
                boton1 = {<div><i className={button2.icon}></i> {button2.text}</div>}
                boton2 = {<div>Cancelar</div>}
                funcion1 = {enviar}
                funcion2 = {() => {this.setState({
                    openHome: false,
                    openWCita: false
                })}}
            />
        );
    }
    
    showModalPago = () => {
        const { openWPago, button1, num, fecha, deudaT, otroMonto, total, otro, concepto, selectcuenta,
            cuentas, titular, ciTitular, tlfTitular } = this.state;
        let campos = {num, fecha, deudaT, otroMonto, total, otro, concepto, selectcuenta, titular, ciTitular, tlfTitular};

        const styles = {
            padding: 2, fontSize: 12
        }

        let pagar = () => {
            if (this.state.button1.disabled === true) return null;
            this.setState({
                openHome: false,
                button1: {
                    icon:"fa fa-spinner fa-spin",
                    text:"Espera",
                    disabled: true
                }
            }, () => {
                Pagar (campos, this.state.deudaT.deudaVencida, (resp) => {
                    if (resp[0] === "Error"){
                        this.setState({
                            button1: {
                                icon:"fa fa-check",
                                text:"Registrar",
                                disabled: false
                            }  
                        })
                    }else{
                        this.setState({
                            num:"",
                            fecha: fecha,
                            otroMonto: "",
                            total: true,
                            otro: false,
                            concepto: "",
                            openWPago: false,
                        }, () => {
                            ConsultCuenta ((resp) => {
                                let textCuenta = this.state.textPrelCuenta;
                    
                                if (resp.length === 0){
                                    statusUser = 1
                                }else{
                                    statusUser = 2;
                                    textCuenta = ""
                                }
                    
                                this.setState({
                                    asientos: resp,
                                    textPrelCuenta: textCuenta,
                                    button1: {
                                        icon:"fa fa-check",
                                        text:"Registrar",
                                        disabled: false
                                    },
                                })
                            })
                        })
                    }
                    
                    toast[resp[2]](resp[1],{autoClose: 4000});
                })
            })
        }
        let contenidoMess = () => (
            <Row>
                <Col md={8}>
                    <Select
                        isSearchable ={true}
                        value={selectcuenta}
                        onChange={this.valorCuenta}
                        options={cuentas}
                    />
                    <div className="text-muted" style={{fontSize: 9}}>(*) Seleccciona el número de cuenta al cual hiciste la transferencia</div>
                </Col>
                <Col md={4}>
                    <button className="btn btn-danger" onClick = {() => {this.setState({openWCita: true})}} style={{borderWidth:1}} title="Realizar pago en efectivo"><i className="fa fa-money"></i> Pago en Efectivo</button>
                </Col>
                <Col md={6} className="custom-mt-10">
                    <input maxLength= {20} type="text" value={num} onChange={this.cambiaValor("num")} className="form-control" placeholder="Ej.: 001828212828"/>
                    <div className="text-muted" style={{fontSize: 9}}>(*) N° de Transferencia</div>
                </Col>
                <Col md={6} className="custom-mt-10">
                    <DatePicker
                        clearIcon= {<i className="fa fa-times"></i>}
                        calendarIcon= {<i className="fa fa-calendar"></i>}
                        className="form-control"
                        onChange={this.cambiaFecha}
                        value={fecha}
                    />
                    <div className="text-muted" style={{fontSize: 9}}>(*) Fecha del pago</div>
                </Col>
                <Col md={6} className="custom-mt-10 text-danger">(*) Monto:</Col>
                <Col md={6} className="custom-mt-10 text-danger">Datos del Titular:</Col>
                <Col md={6}>
                    <div className="table-responsive">
                        <Table bordered style={{marginBottom: 0}}>
                            <tbody>
                                <tr>
                                    <td width= "50px" style={styles}>
                                        <Switch height={12} width={24} onChange={() => {this.pagar("total")}} checked={total} />
                                    </td>
                                    <td width= "100%" style={styles}>
                                        <input type="text" maxLength= {10} value={deudaT.totalGral} disabled className="form-control" placeholder="Ej.: 35000"/>
                                        <div className="text-muted" style={{fontSize: 9}}>Monto Total</div>
                                    </td>
                                </tr>
                                <tr>
                                    <td width= "50px" style={styles}>
                                        <Switch height={12} width={24} onChange={() => {this.pagar("otro")}} checked={otro} />
                                    </td>
                                    <td width= "100%" style={styles}>
                                        <input type="number" maxLength= {10} value={otroMonto} onFocus={() => {this.setState({
                                            openHome: false, total: false, otro: true
                                        })}} onChange={this.cambiaValor("otroMonto")} className="form-control" placeholder="Ej.: 35000"/>
                                        <div className="text-muted" style={{fontSize: 9}}>Otro Monto</div>
                                    </td>
                                </tr>
                            </tbody>
                        </Table>
                    </div>
                </Col>
                <Col md={6}>
                    <Row>
                        <Col md = {12}>
                            <input type="text" maxLength= {50} className="form-control" onChange={this.cambiaValor("titular")} value={titular}/>
                            <div className="text-muted" style={{fontSize: 10}}>(*) Titular de la Cuenta</div>
                        </Col>
                        <Col md = {12} style ={{marginTop: 5}}>
                            <input type="text" maxLength= {20} className="form-control" onChange={this.cambiaValor("ciTitular")} value={ciTitular}/>
                            <div className="text-muted" style={{fontSize: 10}}>(*) N° de Cédula del Titular</div>
                        </Col>
                    </Row>
                </Col>
                <Col md={12}>
                    <Row>
                        <Col md={6} className = "custom-mt-20">
                            <input type="number" maxLength= {11} className="form-control" placeholder="Ej.: 04121234567" onChange={this.cambiaValor("tlfTitular")} value={tlfTitular}/>
                            <div className="text-muted" style={{fontSize: 10}}>Número de teléfono <strong>(Solo en caso de PAGO MÓVIL)</strong></div>
                        </Col>
                        <Col md={6} className = "custom-mt-20">
                            <input type="text" maxLength= {50} onChange={this.cambiaValor("concepto")} className="form-control" value={concepto} placeholder="Ej.: PAGO DE MENSUALIDAD"/>
                            <div className="text-muted" style={{fontSize: 10}}>Descripción</div>
                        </Col>
                    </Row>
                </Col>
                <Col md={12} className="text-muted custom-mt-10" style={{fontSize: 10}}>Los campos con asterisco (*) son obligatorios</Col>
                <Col md={12} className="text-danger" style={{fontSize: 10}} align="right">Al realizar la transferencia debes tener en cuenta que son revisadas el dia siguiente asi sea del mismo banco</Col>
            </Row>
        )
        
        return (
            <CustomModal
                isopen =  {openWPago}
                titulo = {<div className="text-danger" style={{fontSize: 14}}><i className="fa fa-money"></i> Registrar Pago en Línea</div>}
                contenido = {contenidoMess()}
                boton1 = {<div><i className={button1.icon}></i> {button1.text}</div>}
                boton2 = {<div>Cancelar</div>}
                funcion1 = {pagar}
                funcion2 = {() => {this.setState({
                    openHome: false,
                    openWPago: false
                })}}
            />
        );
    }

    showModalMensaje = () => {
        let { openHome } = this.state;

        let contenidoModal = () => (
            <Row>
                <Col md = {12} align="center" className="text-danger"><strong style={{fontSize: 20}}><i className="fa fa-exclamation-triangle"></i> EVITA QUE TUS PAGOS SEAN RECHAZADOS</strong></Col>
                <Col md = {12} className= "custom-mt-10" align="justify" style = {{padding: 30}}>
                    <div>Revisa que estas ingresando <strong>CORRECTAMENTE</strong> el monto tal y como aparece en la transferencia, ya que si este no coincide será rechazada</div>
                    <div className= "custom-mt-10"><strong>NO INGRESES</strong>  pagos que no has hecho ya que esto te puede acarrear sanciones</div>
                    <div className= "custom-mt-10">Una vez que hagas el registro de un pago, debes esperar que sea <strong>VERIFICADO</strong> (esto puede tardar hasta 48 horas, dependiendo de la cantidad de transacciones anteriores a la tuya o el banco)</div>
                    <div className= "custom-mt-10">Solo puedes realizar <strong>UN PAGO A LA VEZ</strong>, para realizar otro pago debes esperar que el anterior sea verificado</div>
                </Col>
            </Row>
        )

        return (
            <CustomModalHome
                large = "medium"
                isopen =  {openHome}
                contenido = {contenidoModal()}
                cerrar = {() => this.setState({
                    openHome: false
                })}
            />
        )
    }

    contenidOk = () => {
        let { notificacionStyles, ValorUc, textPrelCuenta, asientos, deudaT, nuCuenta } = this.state;

        const styles = {
            padding: 5, fontSize: 12
        }

        const styles2 = {
            padding: 5, fontSize: 10
        }

        const stylesBs = {
            padding: 3, fontSize: 10
        }

        let botones = () => {
            if (asientos.length === 0) return (
                <button className="btn btn-relleno-danger" onClick= {() => {this.setState({
                    openHome: false,
                    openWPago: true
                })}} style={{borderWidth: 1}} title="Si ya realizaste el pago mediante transferencia puedes hacer click aqui para registrarlo"><i class="fa fa-money"></i> Registrar Pago</button>
            )

            let pendientes = 0 ;

            for (let i in asientos) {
                if (asientos[i].status === "0") pendientes++;
            }

            if (pagoHab === "") return (
                <button className="btn btn-relleno-danger" style={{borderWidth: 1}} title="Cargando"><i class="fa fa-spinner fa-spin"></i> Espera</button>
            )


            let contenidoHab = (
                <Popover bsSize="large" id="Inscrito">
                    <div className="custom-alert-danger">No puedes realizar este proceso.</div>
                    <div align="justify" className="custom-mt-10">
                        El proceso de registro de pagos actualmente no se encuentra activo, vuelve a intentarlo luego.
                    </div>
                    <div align="justify" className="custom-mt-10">
                        Ten en cuenta que si es fin de semana posiblemente esté desactivado
                    </div>
                </Popover>
            )

            if (pagoHab === 0) return (
                <OverlayTrigger trigger="focus" placement="right" overlay={contenidoHab}>
                    <button style={{borderWidth: 1}} className="btn btn-relleno-danger"><i className="fa fa-money"></i> Registrar Pago</button>
                </OverlayTrigger>
            )

            if (pendientes === 0) return (
                <button className="btn btn-relleno-danger" onClick= {() => {this.setState({
                    openHome: false,
                    openWPago: true
                })}} style={{borderWidth: 1}} title="Si ya realizaste el pago mediante transferencia puedes hacer click aqui para registrarlo"><i class="fa fa-money"></i> Registrar Pago</button>
            )

            let contenido = (
                <Popover bsSize="large" id="Inscrito">
                    <div className="custom-alert-danger">No puedes realizar este proceso.</div>
                    <div align="justify" className="custom-mt-10">
                        Tienes pagos anteriores pendientes por aprobación. (Ten en cuenta que si haces el pago desde otro banco. la transacción tardará al menos un dia hábil para hacerse efectiva)
                    </div>
                    <div align="justify" className="custom-mt-10">
                        Para realizar otro pago debes esperar la validación del pago anterior.
                    </div>
                </Popover>
            )

            return (
                <OverlayTrigger trigger="focus" placement="right" overlay={contenido}>
                    <button style={{borderWidth: 1}} className="btn btn-relleno-danger"><i className="fa fa-money"></i> Registrar Pago</button>
                </OverlayTrigger>
            )
        }

        let pagos = () => {
            if (deudaT.info === "Verificando Información, espera por favor") return (
                <div align="center" className="custom-mt-10">
                    <i className="fa fa-spinner fa-spin"></i> Cargando
                </div>
            )

            if (errores > 0) return (
                <div align="center" className="custom-mt-10 text-danger">
                    <i className="fa fa-times-circle"></i> Tu Estado de Cuenta presenta un error. Ponte en contacto con Administración
                </div>
            )

            if (parseInt(deudaT.totalGral) <= 0)return (
                <div align="center" className="custom-mt-10">
                    <i className="fa fa-check-circle text-success"></i> Felicidades. Estas al día
                </div>
            )
            

            return(
                <div className="custom-alert-danger custom-mt-10" style={{padding: 5}}>
                    <Row>
                        <Col md ={12}>
                            <div className="table-responsive" style={{backgroundColor: "#FFF", border:"1px solid #bf4747"}}>
                                <Table striped hover style={{marginBottom: 0}}>
                                    <tbody>
                                        <tr>
                                            <td width="70%" style={styles}>
                                                Deuda Pendiente
                                                <div style={{fontSize: 10}}><strong>Vence: {deudaT.vencimiento}</strong></div>
                                            </td>
                                            <td width="30%" style={styles} align="right">
                                                {formatNumber(deudaT.deuda)} Bs.
                                                {/* <div className = "text-danger" style = {{fontWeight: "bold"}}>{formatReconver(deudaT.deuda)} Bs.</div> */}
                                            </td>
                                        </tr>
                                        {/* <tr>
                                            <td width="70%" style={styles}>Deuda Vencida</td>
                                            <td width="30%" style={styles} align="right">{formatNumber(deudaT.deudaVencida)} Bs.</td>
                                        </tr> */}
                                        <tr>
                                            <td width="70%" style={styles}>Intereses Deuda Vencida</td>
                                            <td width="30%" style={styles} align="right">
                                                {formatNumber(deudaT.interes)} Bs.
                                                {/* <div className = "text-danger" style = {{fontWeight: "bold"}}>{formatReconver(deudaT.interes)} Bs.</div> */}
                                            </td>
                                        </tr>
                                        <tr style = {{backgroundColor: "#a0555c", color: "#ffffff"}}>
                                            <td width="70%" style={styles}><strong style = {{fontSize: 14}}>TOTAL A PAGAR</strong></td>
                                            <td width="30%" style={styles} align="right">
                                                <strong style = {{fontSize: 14}}>{formatNumber(deudaT.totalGral)} Bs.</strong>
                                                {/* <div style = {{fontWeight: "bold"}}>{formatReconver(deudaT.totalGral)} Bs.</div> */}
                                            </td>
                                        </tr>
                                    </tbody>
                                </Table>
                            </div>
                        </Col>
                        <Col md ={12} align="right" className="custom-mt-10">
                            {botones()}
                        </Col>
                    </Row>
                </div>
            )
        }

        let contentEstado = () => {
            if (asientos.length === 0) return (
                <tr>
                    <td colSpan={6} align= "center" style={{padding: 5, fontSize: 12}}>
                        {textPrelCuenta}
                    </td>
                </tr>
            )

            let bs = (monto) => {
                let bs = `${formatNumber(monto)}`;
                let bsConv = `${formatReconver(monto)}`;
                if (monto === "" || monto === null) bs = "";
            
                return (
                    <React.Fragment>
                        <div>{bs}</div>
                        {/* <div className = "text-danger" style = {{fontWeight: "bold"}}>{bsConv}</div> */}
                    </React.Fragment>
                )
            }

            let icono = (mess, status) => {
                let icono = <i className="fa fa-check-circle text-success"></i>;
                if (status === "0") icono = <i className="fa fa-exclamation-triangle text-warning"></i>;
                if (mess === "Error") icono = <i className="fa fa-times-circle text-danger"></i>;

                return icono;
            }

            let status = (mess, status) => {
                let styles = {color:"#000"}
                if (status === "0") styles = {backgroundColor: "#f8f2ee", color:"#a80012", cursor:"pointer"}
                if (mess === "Error") styles = {backgroundColor: "#fff4f6", color:"#A0555C", cursor:"pointer"}

                return styles;
            }

            let aviso = (mess, status) => {
                let aviso = "";
                if (status === "0") aviso = "Esta transacción está pendiente de aprobación";
                if (mess === "Error") aviso = "Esta transacción presenta un problema. Ponte en contacto con Administración";

                return aviso;
            }

            return (
                asientos.map(option => (
                    <tr key = {option.num} style={status(option.resultado, option.status)} title ={aviso(option.resultado, option.status)}>
                        <td align="center" style={{padding: 5, fontSize: 10}}>{option.num}</td>
                        <td align="center" style={{padding: 5, fontSize: 10}}>{option.fecha}</td>
                        <td style={{padding: 5, fontSize: 10}}>{option.descripcion}</td>
                        <td align="center" style={stylesBs}>{bs(option.debe)}</td>
                        <td align="center" style={stylesBs}>{bs(option.haber)}</td>
                        <td align="center" style={stylesBs}>
                            {formatNumber(option.saldo)}
                            {/* <div className = "text-danger" style = {{fontWeight: "bold"}}>{formatReconver(option.saldo)}</div> */}
                        </td>
                        <td align="center" style={styles}>{icono(option.resultado, option.status)}</td>
                    </tr>
                ))
            )
        }

        let numCuenta = () => {
            if (nuCuenta.length === 0) return (
                <tr>
                    <td colSpan={5} align= "center" style={{padding: 5, fontSize: 12}}>
                        <i className="fa fa-spinner fa-spin"></i> Cargando
                    </td>
                </tr>
            )

            return (
                nuCuenta.map(option => (
                    <tr key = {option.id}>
                        <td style={{padding: 5, fontSize: 10}}>{option.titular}</td>
                        <td style={{padding: 5, fontSize: 10}}>{option.rif}</td>
                        <td style={{padding: 5, fontSize: 10}}>{option.cuenta}</td>
                        <td style={styles}>{option.tipo}</td>
                        <td style={styles}>{option.banco}</td>
                    </tr>
                ))
            )
        }

        let contenido = () => (
            <Row>
                <Col md={12} align="right" className="text-danger">
                    <h5 style={{paddingTop: 0}}>Valor actual de la Unidad de Crédito: <span className="badge badge-red">
                        {formatNumber(ValorUc)} Bs.
                        {/* <div style = {{fontWeight: "bold"}}>{formatReconver(ValorUc)} Bs.</div> */}
                    </span></h5>
                </Col>
                <Col md={12}>
                    <div className="custom-alert-info" style={{padding: 4}}>
                        <div className="table-responsive" style={{overflowY: "auto", maxHeight:"40vh", backgroundColor: "#FFF", border: "1px solid #1f2f6e"}}>
                            <Table striped hover bordered style={{marginBottom: 0}}>
                                <tbody>
                                    <tr className="custon-back-color">
                                        <td width="10%" align="center"style={styles}><strong>N°</strong></td>
                                        <td width="10%" align="center"style={styles}><strong>Fecha</strong></td>
                                        <td width="40%" style={styles}><strong>Descripción</strong></td>
                                        <td width="12%" align="center" style={stylesBs}><strong>Facturado Bs.</strong></td>
                                        <td width="12%" align="center" style={stylesBs}><strong>Pagado Bs.</strong></td>
                                        <td width="16%" align="center" style={stylesBs}><strong>Balance Bs.</strong></td>
                                        <td width="30px" align="center" style={styles}></td>
                                    </tr>
                                    {contentEstado()}
                                </tbody>
                            </Table>
                        </div>
                    </div>
                </Col>
                <Col md={12} className="custom-mt-10">
                    <div className="custom-alert-info" style={{padding: 4}}>
                        <i className="fa fa-address-book"></i> Números de Cuenta:
                        <div className="table-responsive custom-mt-10" style={{backgroundColor: "#FFF", border: "1px solid #1f2f6e"}}>
                            <Table striped hover style={{marginBottom: 0}}>
                                <tbody>
                                    <tr className="custon-back-color">
                                        <td width="30%" style={styles}><strong>Titular</strong></td>
                                        <td width="15%" style={styles}><strong>Rif</strong></td>
                                        <td width="25%" style={styles}><strong>N° de Cuenta</strong></td>
                                        <td width="15%" style={styles}><strong>Tipo de Cuenta</strong></td>
                                        <td width="15%" style={styles}><strong>Banco</strong></td>
                                    </tr>
                                    {numCuenta()}
                                </tbody>
                            </Table>
                        </div>
                    </div>
                </Col>
                <Col md={12} className="custom-mt-10">
                    <div className="custom-alert-success"><i className="fa fa-credit-card"></i> Pagos Pendientes:</div>
                    {pagos()}
                </Col>
            </Row>
        )

        return (
            <React.Fragment>
                <div className="content">
                    <Grid fluid>
                        <Row>
                            <Col md={8}>
                                <div className={deudaT.classInfo} style={{padding:10}}>
                                    <Row>
                                        <Col md={11}><div style={{fontSize:16}}>{deudaT.info}</div></Col>
                                        <Col md={1}><i className={deudaT.icono} style={notificacionStyles}></i></Col>
                                    </Row>
                                </div>
                                <div className="custom-mt-10">
                                    <CustomCard
                                        title={`Mi Estado de Cuenta`}
                                        category=""
                                        color="#a80012"
                                        content={contenido()}
                                    />
                                </div>
                            </Col>
                            <Col md={4}>
                                <CustomCard
                                    styles ={{backgroundColor: "#1f2f6e", borderTopLeftRadius: 4, borderTopRightRadius: 4,}}
                                    title={<span style={{color: "#fff"}}><i className="pe-7s-help1"></i> Ayuda</span>}
                                    category={<span style={{color: "#fff"}}>Estado de Cuenta</span>}
                                    color="#a80012"
                                    content={this.ayuda()}
                                />
                            </Col>
                        </Row>
                    </Grid>
                    {this.showModalPago()}
                    {this.showModalCita()}
                    {this.showModalMensaje()}
                </div>
            </React.Fragment>
        )
    }

    render() { 
        switch (statusUser) {
            case 0:
                return(<Preloader/>) 
            case 1:
                return (<Redirect to="/admision" />)
            case 2:
                return (this.contenidOk())
            default:
                return(<Preloader/>) 
        }
    }
}
 
export default EstadoDeCuenta;


// WEBPACK FOOTER //
// ./src/views/EstAdmin/EstadoDeCuenta.jsx